import VueCookie from 'vue-cookie';

export default {
    install (Vue) {
        Vue.use(VueCookie);

        //Method
        Vue.appSetting = () => {
            let config = { apiUrl: 'https://hub.probplus.com' };
            let host = location.origin;

            if (host.indexOf('probplus.com') > -1) {
                //Production
                config.apiUrl = location.protocol + '//hub.probplus.com';
            }

            return config;
        }

        //Probplus Config
        const PPlusConfig = {
            ApiURL: Vue.appSetting().apiUrl
        };

        //Probplus Constants
        const PPlusConstant = {
            // Payment
            PaymentStatus_None: 0,
            PaymentStatus_NeedPayExam: 1,
            PaymentStatus_WaitForConfirm: 2,
            PaymentStatus_Paid: 3,
            // Exam
            ExamStatus_PendingClass: 0,
            ExamStatus_PendingExam: 1,
            ExamStatus_PassExam: 2,
            // Product Type
            ProductType_Class: 0,
            ProductType_ReExam: 1
        };

        //Probplus Authen
        let PPlusAuthen = {
            IsAuthen: false
        };

        //Probplus Engine
        const PPlusEngine = {
            highlightInvalidField(invalid) {
                if (!invalid) {
                    return '';
                }

                return 'invalid';
            },
            getHeaderToken() {
                return {
                    headers: { Authorization: 'Bearer ' + Vue.cookie.get('token') }
                };
            },
            getDateText(input, lang) {
                var date = new Date(input.substring(0, 10));

                var monthName = [
                    { name_th: 'มกราคม', name_en: 'January' },
                    { name_th: 'กุมภาพันธุ์', name_en: 'February' },
                    { name_th: 'มีนาคม', name_en: 'March' },
                    { name_th: 'เมษายน', name_en: 'April' },
                    { name_th: 'พฤษภาคม', name_en: 'May' },
                    { name_th: 'มิถุนายน', name_en: 'June' },
                    { name_th: 'กรกฎาคม', name_en: 'July' },
                    { name_th: 'สิงหาคม', name_en: 'August' },
                    { name_th: 'กันยายน', name_en: 'September' },
                    { name_th: 'ตุลาคม', name_en: 'October' },
                    { name_th: 'พฤศจิกายน', name_en: 'November' },
                    { name_th: 'ธันวาคม', name_en: 'December' }
                ];
            
                var day = date.getDate();
                var monthIndex = date.getMonth();
                var year = date.getFullYear();

                if (lang == 'TH') {
                    return day + ' ' + monthName[monthIndex].name_th + ' ' + (year + 543);
                }

                if (lang == 'EN') {
                    return day + ' ' + monthName[monthIndex].name_en + ' ' + year;
                }

                return '';
            },
            getDictionary(lang, th, en) {
                switch (lang) {
                    case 'th':
                        return th;

                    case 'en':
                        return en;

                    default:
                        return '';
                }
            }
        };

        Vue.prototype.$PPlusConfig = PPlusConfig;
        Vue.prototype.$PPlusConstant = PPlusConstant;
        Vue.prototype.$PPlusAuthen = PPlusAuthen;
        Vue.prototype.$PPlusEngine = PPlusEngine;
    }
}